const categoryTagType = {
    name_en: '',
    name_de: '',
};

export const formInitialValues = {
    categoryTagType,
};
